// Nutragen Theme JS

// Scroll reveal
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.1 });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// Mobile menu
const toggle = document.getElementById('menu-toggle');
const nav = document.getElementById('site-nav');
if (toggle && nav) {
  toggle.addEventListener('click', () => nav.classList.toggle('open'));
  document.addEventListener('click', (e) => {
    if (!toggle.contains(e.target) && !nav.contains(e.target)) nav.classList.remove('open');
  });
}

// Cart add feedback
document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', function() {
    this.textContent = '✓ Agregado';
    setTimeout(() => { this.textContent = 'Agregar'; }, 2000);
  });
});
